

<div class="container">
  <div #modelContainer class="configuration-panel" fxLayout="row" fxLayoutAlign="center center">
    <!-- <model-viewer id="glb-product-link" style="width: 100vw; height: 100vh;"
      shadow-intensity="1" camera-controls touch-action="pan-y"
      [src]="url"
      [ios-src]="urlIos"
      data-js-focus-visible=""
      ar-status="not-presenting"
      alt="Model preview"
      min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
      auto-rotate
      ar ar-modes="scene-viewer webxr quick-look"
      environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.hdr"
      min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
      auto-rotate>
    </model-viewer> -->
    <!-- cant support ios again just yet -->
    <model-viewer id="glb-product-link" style="width: 100vw; height: 100vh;"
      shadow-intensity="1" camera-controls touch-action="pan-y"
      [src]="url"
      data-js-focus-visible=""
      ar-status="not-presenting"
      alt="Model preview"
      min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
      auto-rotate
      ar ar-modes="scene-viewer webxr quick-look"
      environment-image="https://cdn.situsystems.com/products/small_empty_room_3_4k.hdr"
      min-camera-orbit="auto auto 10%" max-camera-orbit="auto auto 100%"
      auto-rotate>
    </model-viewer>

    <div class="top-overlay" fxLayout="row" fxLayoutAlign="space-between center">
      <mat-icon *ngIf="linkToPortal" class="link m-l-10 m-t-5" matTooltip="View in situPORTAL" aria-label="viewInPortal" 
        (click)="openInPortal()" matTooltipPosition="below" aria-hidden="false">
        exit_to_app
      </mat-icon>
    </div>

    <div class="homeconfig" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="4px">
      <a target="_blank" href="https://situsystems.com/"><img class="logo" src="https://cdn.situsystems.com/facade/2d7f08ea-ccdc-4c39-85ce-4e987ea79e65.png" alt="situSYSTEMS" matTooltip="situSYSTEMS"></a> 
    </div>
  </div>
</div>